import React from 'react';

function Notfound(){

    return (
       
        <>
        404
        </>
    )
}

export default Notfound;